import { Injectable } from '@angular/core';
import { HttpModelConverter } from 'src/app/modules/core/converter/httpModel.converter';
import { MedicalSterilizationSummaryModel } from '../medicalSterilizationSummary.model';
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {UserSummaryConverter} from "../../../../../../account/modules/user/api/converter/userSummary.converter";

@Injectable({
  providedIn: 'root'
})
export class MedicalSterilizationSummaryConverter extends HttpModelConverter<MedicalSterilizationSummaryModel> {
  constructor(private userSummaryConverter: UserSummaryConverter,
              private dateConverter: DateConverter) {
    super();
  }

  protected createInstance(): MedicalSterilizationSummaryModel {
    return new MedicalSterilizationSummaryModel();
  }

  protected enrichObject(result: MedicalSterilizationSummaryModel, src: MedicalSterilizationSummaryModel) {
    result.responsibleUser = this.userSummaryConverter.convert(src.responsibleUser);
    result.sterilizationDate = this.dateConverter.convert(src.sterilizationDate);
    result.validationDate = this.dateConverter.convert(src.validationDate);
  }
}

